import { t } from 'i18next'
import { ProductAttributeGroup } from 'types/model/product'
import { contentLanguages } from 'lib/languages'
import { useState } from 'react'
import { useFormikContext } from 'formik'
import { formatMultiLanguageField } from 'lib/utils'
import { AttributeModal } from './AttributeModal'

type AddNoteModalType = {
  modal: { right: boolean }
  handleCloseModal: () => void
  attributeGroup: ProductAttributeGroup
  fieldBase: string
  id: string
}

type FieldValueType =
  | string
  | undefined
  | {
      options: { [lang: string]: string }
      contentLanguage: string
    }
  | boolean

export const AddAttributeModal = ({
  modal,
  handleCloseModal,
  attributeGroup,
  fieldBase,
  id,
}: AddNoteModalType) => {
  const { setFieldValue } = useFormikContext()
  const [name, setName] = useState({
    options: formatMultiLanguageField(undefined),
    contentLanguage: contentLanguages[0],
  })
  const [type, setType] = useState<string | null>(null)
  const [facetAttribute, setFacetAttribute] = useState(false)
  const [booleanValue, setBooleanValue] = useState<string | null>(null)
  // controlled mui input needs default to be empty string
  const [numberValue, setNumberValue] = useState<string>('')
  const [stringValue, setStringValue] = useState({
    options: formatMultiLanguageField(undefined),
    contentLanguage: contentLanguages[0],
  })

  const handleBlur = (fieldName: string, value: FieldValueType) => {
    const attributeIndex = attributeGroup.productAttribute.findIndex(
      (attribute) => attribute.id === id
    )
    setFieldValue(`${fieldBase}.${attributeIndex}.${fieldName}`, value)
  }

  const clearValueField = () => {
    setStringValue({
      options: formatMultiLanguageField(undefined),
      contentLanguage: contentLanguages[0],
    })
    setBooleanValue(null)
    setNumberValue('')
  }

  const handleClose = () => {
    setName({
      options: formatMultiLanguageField(undefined),
      contentLanguage: contentLanguages[0],
    })
    setType(null)
    setFacetAttribute(false)
    clearValueField()
    handleBlur('isFacetAttribute', facetAttribute)
    handleCloseModal()
  }

  return (
    <AttributeModal
      title={t('addAttribute')}
      modal={modal}
      handleClose={handleClose}
      handleBlur={handleBlur}
      name={name}
      type={type}
      facetAttribute={facetAttribute}
      booleanValue={booleanValue}
      stringValue={stringValue}
      numberValue={numberValue}
      setFacetAttribute={setFacetAttribute}
      setStringValue={setStringValue}
      setNumberValue={setNumberValue}
      setBooleanValue={setBooleanValue}
      setType={setType}
      setName={setName}
    />
  )
}
